import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BaseService} from "../base.service";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {catchError, tap} from "rxjs/operators";
import {DynamicListEntity} from "../../models/list/dynamic-list-entity";

@Injectable()
export class ListService extends BaseService<any> {

  constructor(public httpClient: HttpClient) {
    super('list', httpClient);
  }
  search(endPoint: string, params: any = null): Observable<DynamicListEntity> {
    const query = encodeURI(JSON.stringify(params || {}));
    let url = new URL(environment.baseUrl + '/list/search').updateQueryParam({ endPoint, query })
    return this.httpClient.get<DynamicListEntity>(url.toString(), { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
  }
}
